import { render, staticRenderFns } from "./EmotionGame.vue?vue&type=template&id=d9018bde&scoped=true&"
import script from "./EmotionGame.vue?vue&type=script&lang=js&"
export * from "./EmotionGame.vue?vue&type=script&lang=js&"
import style0 from "./EmotionGame.vue?vue&type=style&index=0&id=d9018bde&scoped=true&lang=scss&"
import style1 from "./EmotionGame.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9018bde",
  null
  
)

export default component.exports